module.exports = __webpack_public_path__ + "static/img/rank_135.edc9973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_135.png
// module id = 0U74
// module chunks = 0